import Complaint from './complaint.vue';

export default Complaint;
